// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-quick-panel {
  display: flex;
  width: 350px;
  min-width: 350px;
  max-width: 350px;
  z-index: 99;
  flex-direction: column;
}
app-quick-panel .mat-slide-toggle-content {
  flex: 1;
}
app-quick-panel .span-spacer {
  flex: 1 1 auto;
}
app-quick-panel .time-alert {
  text-align: right;
  color: gray;
  margin-top: 10px;
}
app-quick-panel .cursor-pointer {
  float: right;
  cursor: pointer;
}
app-quick-panel .mat-list-text {
  padding-right: 16px !important;
}
app-quick-panel .show-alert {
  height: auto !important;
  margin-bottom: 25px;
  margin-top: 15px;
}
app-quick-panel .show-alert .error-message {
  white-space: inherit !important;
}

/*Help Tab*/
.msg-writing {
  background-color: #F2F2F2;
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 400;
  font-family: "Mulish", sans-serif;
  border-radius: 10px 10px 10px 0;
  word-wrap: break-word;
  padding: 9px 13px;
  color: #000000;
  margin-top: 5px;
  line-height: 20px;
  max-width: 70%;
  min-height: 17px;
  min-width: 38px;
  margin-left: 5%;
  margin-bottom: 5%;
  position: fixed;
  bottom: 0;
}

.chat {
  margin-top: 5%;
  overflow-y: auto;
  height: 60%;
  background-color: white;
}

.p-message-detail {
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/app/main/quick-panel/quick-panel.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AACJ;AACI;EACI,OAAA;AACR;AAEI;EACI,cAAA;AAAR;AAGI;EACI,iBAAA;EACA,WAAA;EACA,gBAAA;AADR;AAII;EACI,YAAA;EACA,eAAA;AAFR;AAKI;EACI,8BAAA;AAHR;AAMI;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;AAJR;AAMQ;EACI,+BAAA;AAJZ;;AASA,WAAA;AACA;EACE,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,iCAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;AANF;;AASA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;AANF;;AASA;EACE,qBAAA;AANF","sourcesContent":["app-quick-panel {\r\n    display: flex;\r\n    width: 350px;\r\n    min-width: 350px;\r\n    max-width: 350px;\r\n    z-index: 99;\r\n    flex-direction: column;\r\n\r\n    .mat-slide-toggle-content {\r\n        flex: 1;\r\n    }\r\n\r\n    .span-spacer {\r\n        flex: 1 1 auto;\r\n    }\r\n    \r\n    .time-alert {\r\n        text-align: right;\r\n        color: gray;\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .cursor-pointer {\r\n        float: right;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .mat-list-text {\r\n        padding-right: 16px !important;\r\n    }\r\n\r\n    .show-alert {\r\n        height: auto !important;\r\n        margin-bottom: 25px;\r\n        margin-top: 15px;\r\n\r\n        .error-message {\r\n            white-space: inherit !important;\r\n        }\r\n    }\r\n}\r\n\r\n/*Help Tab*/\r\n.msg-writing {\r\n  background-color: #F2F2F2;\r\n  font-size: 14px;\r\n  letter-spacing: 0.5px;\r\n  font-weight: 400;\r\n  font-family: 'Mulish', sans-serif;\r\n  border-radius: 10px 10px 10px 0;\r\n  word-wrap: break-word;\r\n  padding: 9px 13px;\r\n  color: #000000;\r\n  margin-top: 5px;\r\n  line-height: 20px;\r\n  max-width: 70%;\r\n  min-height: 17px;\r\n  min-width: 38px;\r\n  margin-left: 5%;\r\n  margin-bottom: 5%;\r\n  position: fixed;\r\n  bottom: 0;\r\n}\r\n\r\n.chat {\r\n  margin-top: 5%;\r\n  overflow-y: auto;\r\n  height: 60%;\r\n  background-color: white;\r\n}\r\n\r\n.p-message-detail {\r\n  word-break: break-all;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
